import React from "react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import ScrollToTopButton from "../components/ScrollToTopButton";
import Reveal from "../components/Reveal";
import { HERO_IMAGE, LEADERSHIP, EDITORIAL_TEAM, SECTION_TEAMS, memberImage } from "../data/members";

// Section A: public. "درباره ما" — introduces the people behind دریچه,
// pulled from data/members.js. Three tiers, largest role first: the two
// people running the magazine, the editorial/business desks, then the
// four two-person section teams.
function AboutPage() {
  return (
    <div className="site">
      <SiteHeader />

      <main>
        <section className="about-hero">
          <img className="about-hero-image" src={HERO_IMAGE} alt="اعضای تحریریهٔ دریچه" />
          <div className="about-hero-shade" />
          <div className="about-hero-copy">
            <span className="about-hero-kicker">دربارهٔ ما</span>
            <h1>خانوادهٔ دریچه</h1>
            <p>آن‌هایی که هر شماره را، صفحه به صفحه، از ایده تا چاپ، با هم می‌سازند.</p>
          </div>
        </section>

        <div className="dimension-divider">
          <span className="dimension-line" />
          <span className="dimension-label">کیوریتور</span>
          <span className="dimension-line" />
        </div>

        <section className="leadership-row">
          {LEADERSHIP.map((person, index) => (
            <Reveal key={person.slug} delay={index * 100} className="leadership-reveal">
              <article className="leadership-card">
                <span className="corner corner-tr" />
                <span className="corner corner-tl" />
                <span className="corner corner-br" />
                <span className="corner corner-bl" />

                <div className="leadership-card-image-frame">
                  <img src={memberImage(person.slug)} alt={person.name} />
                </div>

                <div className="leadership-card-body">
                  <span className="leadership-card-job">{person.job}</span>
                  <h2>{person.name}</h2>
                </div>
              </article>
            </Reveal>
          ))}
        </section>

        <div className="dimension-divider">
          <span className="dimension-line" />
          <span className="dimension-label">گردآورندگان</span>
          <span className="dimension-line" />
        </div>

        <section className="team-grid">
          {EDITORIAL_TEAM.map((person, index) => (
            <Reveal key={person.slug} delay={index * 60}>
              <article className="team-card">
                <span className="corner corner-tr" />
                <span className="corner corner-tl" />
                <span className="corner corner-br" />
                <span className="corner corner-bl" />

                <div className="team-card-image-frame">
                  <img src={memberImage(person.slug)} alt={person.name} />
                </div>

                <h3>{person.name}</h3>
                <span className="team-card-job">{person.job}</span>
              </article>
            </Reveal>
          ))}
        </section>

        <div className="dimension-divider">
          <span className="dimension-line" />
          <span className="dimension-label">هیئت تحریریه</span>
          <span className="dimension-line" />
        </div>

        <section className="section-teams">
          {SECTION_TEAMS.map((team, index) => (
            <Reveal key={team.job} delay={index * 80}>
              <article className="section-team">
                <h3 className="section-team-job">{team.job}</h3>
                <div className="section-team-members">
                  {team.members.map((person) => (
                    <div className="section-team-member" key={person.slug}>
                      <div className="section-team-member-image-frame">
                        <img src={memberImage(person.slug)} alt={person.name} />
                      </div>
                      <span className="section-team-member-name">{person.name}</span>
                    </div>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </section>
      </main>

      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}

export default AboutPage;
